import { Boton, PilaH, Texto } from '@/components/atomos';
import { useToast } from '@chakra-ui/react';
import { ChevronRight } from 'lucide-react';

const Soporte = () => {
  const toast = useToast();

  const copiarMailContacto = () => {
    if (navigator?.clipboard) {
      navigator.clipboard.writeText('contacto@temba.cl');
      toast({
        title: 'Mail de contacto copiado',
        status: 'success',
        isClosable: true,
        duration: 2000,
        position: 'top',
      });
    }
  };

  return (
    <PilaH
      p={8}
      w={'full'}
      justifyContent={'space-between'}
      rounded={'md'}
      bgGradient={'linear(to-r, bGreen.600, bGreen.700)'}
    >
      <Texto fontSize={'2xl'} fontWeight={'semibold'} color={'white'}>
        ¿Tienes dudas?
      </Texto>
      <Boton variant={'action'} size={'lg'} onClick={copiarMailContacto}>
        Contacta al soporte <ChevronRight size={18} />
      </Boton>
    </PilaH>
  );
};

export default Soporte;
